import React, { useCallback, useContext, useEffect, useState } from 'react';
import { useDropzone } from 'react-dropzone';

import { Link as RouterLink } from 'react-router-dom';

import {
    Card,
    CardContent,
    CardHeader, CircularProgress, Divider, Grid, IconButton, Link, Table,
    TableBody,
    TableCell, TableRow, TextField, Typography
} from '@mui/material';


import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';

import { ImpostazioneContext } from '../ImpostazioneContext';

import { Formik } from 'formik';
import * as Yup from 'yup';
import { DateTableRow, UtenteTableRow } from '../../../common';

const LinkRouter = props => <Link {...props} component={RouterLink} />;

const ImpostazioneSchema = Yup.object().shape({
});

export const ImpostazioneDetailsForm = ({
    disabled,
    formRef,
    onActionClick,
    ...props }) => {

    const {
        state,
        setState,

        isAddingFile,
        addFileAsync,
    } = useContext(ImpostazioneContext);

    const {
        impostazione,
        iconFiles,
    } = state;

    const handleOnSubmit = async (values) => {
        if (onActionClick)
            if (onActionClick)
                onActionClick("Submit", values);
    }

    const [selectedManualeUtenteUrl, setSelectedManualeUtenteUrl] = useState(null);
    const [isUploading, setIsUploading] = useState(false);

    const onDrop = useCallback(async acceptedFiles => {
        if (isUploading) {
            return;
        }

        setIsUploading(true);
        setSelectedManualeUtenteUrl(await addFileAsync(acceptedFiles[0]));

        setIsUploading(false);
    }, [])

    const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop });

    useEffect(() => {
        setSelectedManualeUtenteUrl(impostazione?.manualeUtenteUrl);
    }, [impostazione])

    return (
        <>
            <Formik
                innerRef={formRef}
                initialValues={
                    {
                        urlANPR: impostazione?.urlANPR ?? "",
                        urlCI: impostazione?.urlCI ?? "",
                        maxCompetenze: impostazione?.maxCompetenze ?? 0,
                        manualeUtenteUrl: selectedManualeUtenteUrl,
                        publicLinkDomain: impostazione?.publicLinkDomain,
                    }
                }
                enableReinitialize
                validationSchema={ImpostazioneSchema}
                onSubmit={handleOnSubmit}
            >
                {({
                    values,
                    handleSubmit,
                    setFieldValue,
                    errors,
                    touched,
                    setTouched,
                    handleChange,
                }) => {
                    return <form onSubmit={handleSubmit}>
                        <Grid container spacing={2} sx={{ marginTop: 2 }}>
                            <Grid item xs={12}>
                                <Card>
                                    <CardHeader
                                        sx={{
                                            color: "white",
                                            backgroundColor: "secondary.main",
                                        }}
                                        title={
                                            <Grid container alignItems="center" justify="space-between">
                                                <Grid item>
                                                    <Typography variant="h6">Informazioni</Typography>
                                                </Grid>
                                            </Grid>
                                        }
                                    />
                                    <Divider />
                                    <CardContent sx={{ padding: "0px !important" }}>
                                        <Table>
                                            <TableBody>
                                                <TableRow>
                                                    <TableCell style={{ width: "20%" }}>
                                                        Numero massimo competenze
                                                    </TableCell>
                                                    <TableCell>
                                                        <TextField
                                                            fullWidth
                                                            id="maxCompetenze"
                                                            name="maxCompetenze"
                                                            value={values.maxCompetenze}
                                                            onChange={handleChange}
                                                            type="number"
                                                            error={touched.maxCompetenze && Boolean(errors.maxCompetenze)}
                                                            inputProps={{ sx: { padding: 1 } }} />
                                                    </TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell style={{ width: "20%" }}>
                                                        Url ANPR
                                                    </TableCell>
                                                    <TableCell>
                                                        <TextField
                                                            fullWidth
                                                            id="urlANPR"
                                                            name="urlANPR"
                                                            value={values.urlANPR}
                                                            onChange={handleChange}
                                                            error={touched.urlANPR && Boolean(errors.urlANPR)}
                                                            inputProps={{ sx: { padding: 1 } }} />
                                                    </TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell style={{ width: "20%" }}>
                                                        Url Comuni Italia
                                                    </TableCell>
                                                    <TableCell>
                                                        <TextField
                                                            fullWidth
                                                            id="urlCI"
                                                            name="urlCI"
                                                            value={values.urlCI}
                                                            onChange={handleChange}
                                                            error={touched.urlCI && Boolean(errors.urlAurlCIPR)}
                                                            inputProps={{ sx: { padding: 1 } }} />
                                                    </TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell style={{ width: "20%" }}>
                                                        Link dominio pubblico
                                                    </TableCell>
                                                    <TableCell>
                                                        <TextField
                                                            fullWidth
                                                            id="publicLinkDomain"
                                                            name="publicLinkDomain"
                                                            value={values.publicLinkDomain}
                                                            onChange={handleChange}
                                                            error={touched.publicLinkDomain && Boolean(errors.publicLinkDomain)}
                                                            inputProps={{ sx: { padding: 1 } }} />
                                                    </TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell style={{ width: "20%" }}>
                                                        Manuale utente
                                                    </TableCell>
                                                    <TableCell style={{ display: "flex", justifyContent: "flex-start", alignItems: "center" }}>
                                                        {
                                                            values.manualeUtenteUrl &&
                                                            <div style={{ display: "flex", alignItems: "center", marginRight: 8 }}>
                                                                <IconButton onClick={() => {
                                                                    window.open(values.manualeUtenteUrl, '_blank');
                                                                }}>
                                                                    <InsertDriveFileIcon />
                                                                </IconButton>
                                                                Manuale
                                                            </div>
                                                        }
                                                        <div
                                                            style={isDragActive && !isUploading ? {
                                                                border: "1px",
                                                                padding: "16px",
                                                                outline: "none",
                                                                display: "flex",
                                                                alignItems: "center",
                                                                justifyContent: "center",
                                                                flexWrap: "wrap",
                                                                backgroundColor: "#e1e1e1",
                                                                opacity: 0.7,
                                                            } : {
                                                                border: "1px",
                                                                padding: "16px",
                                                                outline: "none",
                                                                display: "flex",
                                                                alignItems: "center",
                                                                justifyContent: "center",
                                                                flexWrap: "wrap",
                                                                backgroundColor: "#e1e1e1",
                                                                opacity: 1,
                                                            }}
                                                            {...getRootProps()}>
                                                            <input {...getInputProps()} />
                                                            {isUploading ? <CircularProgress /> : "Trascina o clicca per caricare il manuale"}
                                                        </div>
                                                    </TableCell>
                                                </TableRow>
                                                <UtenteTableRow label={'Creato da'} utenteId={impostazione?.creatoDa} />
                                                <DateTableRow label={'Data creazione'} stringDate={impostazione?.dataCreazione} />
                                                <UtenteTableRow label={'Ultima modifica da'} utenteId={impostazione?.aggiornatoDa} />
                                                <DateTableRow label={'Data ultima modifica'} stringDate={impostazione?.dataAggiornamento} />
                                            </TableBody>
                                        </Table>
                                    </CardContent>
                                </Card>
                            </Grid>
                        </Grid>
                    </form>
                }}
            </Formik>
        </>
    );
}